import { useAPI } from "@humansignal/core";
import { useEffect, useState } from "react";
import "./TracksSettings.prefix.css";

/**
 * Project header control for a person on several tracks of a project where
 * every task is answered in every track: the track they are working in.
 */
export const TrackPicker = ({ project }) => {
  const api = useAPI();
  const [mine, setMine] = useState(null);
  const wanted = project?.id && project.extensions?.tracks?.mode === "each";

  useEffect(() => {
    if (!wanted) return setMine(null);
    let alive = true;
    api.callApi("myTracks", { params: { pk: project.id }, errorFilter: () => true }).then((res) => {
      if (alive) setMine(res?.chooses ? res : null);
    });
    return () => {
      alive = false;
    };
  }, [api, wanted, project?.id]);

  if (!mine) return null;
  const choose = async (e) => {
    const track = Number(e.target.value);
    const res = await api.callApi("chooseTrack", {
      params: { pk: project.id },
      body: { track },
      errorFilter: () => true,
    });
    // The task list is the chosen track's from here on.
    if (res?.working === track) window.location.reload();
  };
  return (
    <select
      className="lsf-track-picker"
      value={mine.working ?? ""}
      onChange={choose}
      aria-label="The track you are working in"
      data-testid="track-picker"
    >
      {mine.tracks.map((t) => (
        <option key={t.id} value={t.id}>
          Working in {t.name}
        </option>
      ))}
    </select>
  );
};
